import logoPicture from "@/assets/logo.png?w=200;320;480;640&format=avif;webp;png&as=picture";

type LogoProps = {
  className?: string;
  alt?: string;
  loading?: "eager" | "lazy";
  fetchPriority?: "high" | "low" | "auto";
  sizes?: string;
};

export function Logo({
  className,
  alt = "Texas Made Shade & Covers logo",
  loading = "eager",
  fetchPriority,
  sizes = "(min-width: 1024px) 224px, (min-width: 768px) 144px, (min-width: 640px) 124px, 92px",
}: LogoProps) {
  const sources = logoPicture.sources as Record<string, string>;
  const fallback = logoPicture.img.src as string;
  const w = logoPicture.img.w as number;
  const h = logoPicture.img.h as number;
  return (
    <picture>
      {Object.entries(sources).map(([type, srcSet]) => (
        <source key={type} type={`image/${type}`} srcSet={srcSet} sizes={sizes} />
      ))}
      <img
        src={fallback}
        alt={alt}
        width={w}
        height={h}
        loading={loading}
        decoding="async"
        {...(fetchPriority ? { fetchPriority } : {})}
        className={className}
      />
    </picture>
  );
}
